// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"01e56a92","455":"c033383d","977":"4dd88baf"}[chunkId] + ".chunk.js";
};